import { PureComponent } from 'react' // eslint-disable-line no-unused-vars
import css from './info-tooltip.css'
import { mobile } from 'shared/util/media-query'
import { useMedia } from 'react-use'

export const TooltipInfo = ({ index, css, text }) => {
    const isMobile = useMedia(mobile.query)
    return (
        <div className={` ${css[`toolTip${index}`]} ${css.toolTip} ${isMobile ? css.arrowTickUp : css.arrowTickLeft}`}>
            <p className={css.content}>{text}</p>
        </div>
    )
}

export const TooltipImage = ({ css }) => {
    return (
        <div className={css.tooltipSvgContainer}>
            <svg className={css.svg} width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
                <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(-943.000000, -542.000000)"
                >
                    <g id="Group-3" transform="translate(89.000000, 344.000000)" fill="#A6A6A6">
                        <g id="Group-4" transform="translate(279.000000, 0.000000)">
                            <g id="Big-Stats" transform="translate(97.000000, 141.000000)">
                                <path
                                    d="M485.5,57 C489.652832,57 493,60.347168 493,64.5 C493,68.652832 489.652832,72 485.5,72 C481.347168,72 478,68.652832 478,64.5 C478,60.347168 481.347168,57 485.5,57 Z M486.646277,69.5 L486.646277,63.0441081 L484.366679,63.0441081 L484.366679,69.5 L486.646277,69.5 Z M485.501221,61.8897393 C486.312084,61.8897393 486.960775,61.2410487 486.960775,60.4387207 C486.960775,59.6278573 486.312084,58.9791667 485.501221,58.9791667 C484.690357,58.9791667 484.041667,59.6278573 484.041667,60.4387207 C484.041667,61.2410487 484.690357,61.8897393 485.501221,61.8897393 Z"
                                    id="info"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    )
}

class AnalyticsTooltip extends PureComponent {
    render() {
        const { isMobile, index, toolTipText } = this.props
        return (
            <div className={css.tooltipWrapper}>
                <TooltipImage css={css} />
                <TooltipInfo index={index} css={css} isMobile={isMobile} text={toolTipText} />
            </div>
        )
    }
}

export default AnalyticsTooltip
